import { render } from "./SpannerPagingControl.vue?vue&type=template&id=d4b9dbfe"
import script from "./SpannerPagingControl.vue?vue&type=script&lang=js"
export * from "./SpannerPagingControl.vue?vue&type=script&lang=js"

import "./SpannerPagingControl.vue?vue&type=style&index=0&id=d4b9dbfe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__